const CustomButton = ({
  children,
  onClick,
  className,
  link,
  disabled = false,
  style,
  title,
  ...rest
}: {
  children: React.ReactNode;
  onClick: () => void;
  link?: string;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  title?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if ((e.metaKey || e.ctrlKey) && link) {
      window.open(link, "_blank");
    } else {
      onClick();
    }
  };
  return (
    <button
      className={className}
      onClick={handleClick}
      disabled={disabled}
      style={style}
      title={title}
      {...rest}
    >
      {children}
    </button>
  );
};

export default CustomButton;
